import React from 'react'
import { AnimatePresence } from 'framer-motion'

import { BounceInDownDiv } from '../../Motion'
import { useContent } from '../../../context/contentProvider'

import { XIcon } from '../../Icons'

import './popup.css'

export const Popup = () => {
    const { formPopup, setFormPopup, formPopupContent } = useContent()
    return (
        <div className="popup">
            <AnimatePresence>
                {formPopup && (
                    <>
                        <div style={{ position: 'fixed', top: 0, left: 0, zIndex: 20, width: '100%', height: '100%', background: 'rgba(0, 0, 0, 0.5)' }} onClick={() => setFormPopup(false)}></div>
                        <BounceInDownDiv style={{ position: 'fixed', top: 0, left: 0, zIndex: 21, width: '100%', height: '100%' }}>
                            <div className="relative content">
                                <button type="button" onClick={() => setFormPopup(false)} style={{ position: 'absolute', top: 10, right: 10, zIndex: 9, margin: 0, padding: 0, cursor: 'pointer', backgroundColor: '#F5333F', border: 0, borderRadius: '5px' }}>
                                    <XIcon color={'#fff'} />
                                </button>
                                <div className="inner-content">
                                    {formPopupContent}
                                </div>
                            </div>
                        </BounceInDownDiv>
                    </>
                )}
            </AnimatePresence>
        </div>
    )
}